import Image from 'next/image'
import { useQuery, gql } from '@apollo/client'

import { Head, Layout, Title } from '@/components'
import Logo from '../../../public/logos/gn-white.svg'
import Drew from '../../../public/images/drew.jpg'

export default function About(props) {
  const { data, loading } = useQuery(gql`
    query SiteData {
      siteData {
        listings
        reviews
      }
    }
  `)
  return (
    <Layout>
      <Head title="" description="Welcome to Good Neighbour" />
      <div className="bg-topography bg-cover bg-fixed absolute inset-0 dark:opacity-10 opacity-[2%] " />
      <div className="relative pt-16 sm:pt-24 pb-24">
        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-24 lg:items-start">
          <div className="relative sm:py-16 lg:py-0">
            <div className="relative mx-auto max-w-md px-6 sm:max-w-3xl sm:px-6 lg:px-0 lg:max-w-none lg:py-20">
              {/* Testimonial card*/}
              <div className="relative pt-72 pb-8 rounded-2xl shadow-subtle overflow-hidden">
                <div className="absolute inset-0 h-full w-full object-cover">
                  <Image src={Drew} />
                </div>
                <div className="absolute inset-0 bg-brand-500 mix-blend-multiply" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-500 via-brand-500 opacity-90" />
                <div className="relative px-8">
                  <div className="w-32 sm:w-56">
                    <Image className="scale-down" alt="Good Neighbour" src={Logo} />
                  </div>
                  <blockquote className="mt-0">
                    <div className="relative text-lg font-medium text-white md:flex-grow">
                      <svg
                        className="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-brand-400"
                        fill="currentColor"
                        viewBox="0 0 32 32"
                        aria-hidden="true"
                      >
                        <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                      </svg>
                      <p className="relative">
                        Housing is a human right and being a landlord is a business. We need to work together to put
                        humans at the forefront.
                      </p>
                    </div>

                    <footer className="mt-4">
                      <p className="text-base font-semibold text-brand-200">Drew Minns, Founder of Good Neighbour</p>
                    </footer>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>

          <div className="relative mx-auto max-w-md  sm:max-w-3xl  px-6 lg:px-0">
            {/* Content area */}
            <div className="pt-12 sm:pt-16 lg:pt-20">
              <Title as="h1" size="2xl">
                We help build
                <br /> happy homes.
              </Title>

              <div className="mt-6 dark:text-zinc-200 text-zinc-500 space-y-6">
                <p className="text-lg font-medium">
                  Good Neighbour is the kinder rental platform for tenants and landlords. For too long the rental market
                  has taken advantage of consumers. Good Neighbour's new renting platform aims to right this imbalance
                  bringing transparency, empowerment, and kindness back to competing interests in the property market.
                </p>
                <p className="text-base leading-7 font-medium">
                  No random strangers. No awkward meetings at the door. Good Neighbour connects you with neighbours who
                  have lived in your neighbourhood and can provide the best insights into your potential apartment or
                  rental home taking away the pressure of online and saving you time, money and energy.
                </p>
                <p className="text-base leading-7 font-medium">
                  We're people just like you, and we are committed to creating a product that makes people's lives
                  better.
                </p>
              </div>
            </div>

            {!loading ? (
              <>
                <div className="mt-10">
                  <dl className="grid grid-cols-3 gap-x-4 gap-y-8 divide-x-2 dark:divide-zinc-700 divide-zinc-100 ">
                    <div className="py-6 text-center">
                      <dt className="text-base font-medium text-zinc-500">Founded</dt>
                      <dd className="text-3xl font-extrabold font-sans text-zinc-700 dark:text-neutral-50 tracking-tight">
                        2021
                      </dd>
                    </div>
                    <div className="py-6 text-center">
                      <dt className="text-base font-medium text-zinc-500">Listings</dt>
                      <dd className="text-3xl font-extrabold font-sans text-zinc-700 dark:text-neutral-50 tracking-tight">
                        {data.siteData.listings}
                      </dd>
                    </div>
                    <div className="py-6 text-center">
                      <dt className="text-base font-medium text-zinc-500">Reviews</dt>
                      <dd className="text-3xl font-extrabold font-sans text-zinc-700 dark:text-neutral-50 tracking-tight">
                        {data.siteData.reviews}
                      </dd>
                    </div>
                  </dl>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </Layout>
  )
}
